import PaywallProBgRebrand from '@/assets/image/free-to-pay/paywall-free-bg-jpg/paywall-free-bg-rebrand.png';
import Image, { type ImageProps } from 'next/image';

export const PaywallFreeBgJpg = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'paywall pro bg', ...rest } = props;

  return <Image src={PaywallProBgRebrand} alt={alt} {...rest} />;
};
